import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SELECTOR_COUNTER = ".counter-animation, body.home-page.newui .component-informationSectionBlock h3.title-content";

export default class FreeTextBlockDomElements extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_COUNTER];

		super($module, selectors);
	}

	getCounterElements() {
		return this.getElements(SELECTOR_COUNTER);
	}
}
